import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const RemovedStatusBadge = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 2px 14px;
	gap: 10px;
	width: 83px;
	height: 24px;
	background: #ffe2e1;
	border-radius: 30px;
	flex: none;
	order: 0;
	flex-grow: 0;

	span {
		width: 55px;
		height: 20px;
		font-family: 'Inter', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		letter-spacing: 0.16px;
		color: #ff4f30;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const ActiveStatusBadge = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 2px 14px;
	gap: 10px;
	width: 83px;
	height: 24px;
	background: #dbffd5;
	border-radius: 30px;
	flex: none;
	order: 0;
	flex-grow: 0;

	span {
		width: 55px;
		height: 20px;
		font-family: 'Inter', sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		letter-spacing: 0.16px;
		color: #07b123;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const ActionButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 10px 20px;
	gap: 10px;
	width: 109px;
	height: 41px;
	background: #fff;
	border-bottom: 1px solid #ececec;
	box-sizing: border-box;
	flex: none;
	order: 2;
	align-self: stretch;
`;

function RemoveFillIcon({ style, onClick }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={style}
			onClick={onClick}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.25 21.5C13.4319 21.5 14.6022 21.2672 15.6942 20.8149C16.7861 20.3626 17.7782 19.6997 18.614 18.864C19.4497 18.0282 20.1126 17.0361 20.5649 15.9442C21.0172 14.8522 21.25 13.6819 21.25 12.5C21.25 11.3181 21.0172 10.1478 20.5649 9.05585C20.1126 7.96392 19.4497 6.97177 18.614 6.13604C17.7782 5.30031 16.7861 4.63738 15.6942 4.18508C14.6022 3.73279 13.4319 3.5 12.25 3.5C9.86305 3.5 7.57387 4.44821 5.88604 6.13604C4.19821 7.82387 3.25 10.1131 3.25 12.5C3.25 14.8869 4.19821 17.1761 5.88604 18.864C7.57387 20.5518 9.86305 21.5 12.25 21.5ZM7.25 13.5H17.25V11.5H7.25V13.5Z"
				fill="#FF3B30"
			/>
		</svg>
	);
}

RemoveFillIcon.propTypes = {
	style: PropTypes.object,
	onClick: PropTypes.func,
};

export default RemoveFillIcon;
